import produce from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.ITermsAndConditionHistoryState = {
    isLoading: true,
    history: []
};

export const reducer = (reducerSuffix: string) =>
    produce((draftState, action: Types.TTermsAndConditionHistoryAction): Types.ITermsAndConditionHistoryState | void => {
        switch (action.type) {
            case actionTypes.TERMS_AND_CONDITIONS_HISTORY_DATA_UPDATE:
            case actionTypes.TERMS_AND_CONDITIONS_HISTORY_DATA_UPDATE + reducerSuffix: {
                Object.assign(draftState, {
                    history: action.payload
                });

                break;
            }
            case actionTypes.TERMS_AND_CONDITIONS_HISTORY_IS_LOADING_TOGGLE:
            case actionTypes.TERMS_AND_CONDITIONS_HISTORY_IS_LOADING_TOGGLE + reducerSuffix: {
                Object.assign(draftState, {
                    isLoading: action.payload
                });

                break;
            }

            default: {
                break;
            }
        }
    }, defaultState);
